// extracted by mini-css-extract-plugin
module.exports = {"Casting":"CastingPermit_Casting__1DVGY","AddCasting":"CastingPermit_AddCasting__1DotZ"};